module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-check-box",
    on: {
      "click": _vm.toggle
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _vm._v(" "), (_vm.sChecked) ? _c('div', {
    staticClass: "check-item"
  }, [_c('a-icon', {
    attrs: {
      "type": "check"
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-63b9b8fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/checkbox/ImgCheckbox.vue
// module id = lQrK
// module chunks = 273